import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { compact } from 'lodash'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Roles from './tabs/Roles'
import Users from './tabs/Users'

const COMPANY_USER_MANAGEMENT_SLUG = 'gerenciamento-de-usuarios-company'
const COMPANY_ROLES_MANAGEMENT_SLUG = 'gerenciamento-de-papeis-company'

const CompanyConfigurationScreen = () => {
  const { pathname } = useLocation()
  const { routes, urlHasPermission } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = (tab) => {
        if (urlHasPermission(tab.slug, 'company')) {
          response.push(tab)
        }
      }

      addTab({
        slug: COMPANY_USER_MANAGEMENT_SLUG,
        route: 'users',
        title: t('user', { howMany: 2 }),
        Component: () => <Users slug={ COMPANY_USER_MANAGEMENT_SLUG } />
      })
      addTab({
        slug: COMPANY_ROLES_MANAGEMENT_SLUG,
        route: 'roles',
        title: t('role', { howMany: 2 }),
        Component: () => <Roles slug={ COMPANY_ROLES_MANAGEMENT_SLUG } />
      })

      return response
    },
    [t, urlHasPermission]
  )

  const crumbs = useMemo(() => compact([
    {
      title: routes.companySettings.title,
      key: 'company-settings-screen',
      url: '/settings/company',
      active: pathname === '/settings/company'
    },
    (
      pathname.includes('users') ? {
        title: t('user', { howMany: 2 }),
        key: 'company-plans-screen',
        url: '/settings/company/users',
        active: pathname === '/settings/company/users'
      } : null
    ),
    (
      pathname.includes('roles') ? {
        title: t('role', { howMany: 2 }),
        key: 'company-roles-screen',
        url: '/settings/company/roles',
        active: pathname === '/settings/company/roles'
      } : null
    )
  ]), [pathname, routes.companySettings.title, t])

  return (
    <Screen title={ routes.companySettings.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default CompanyConfigurationScreen
